export default __webpack_public_path__ + "static/saaS-casestudy-2-2d233adb531b2bec77577f7337876a43.png";